import type { MembersContext } from '@library/types/members';
import { Outlet } from 'react-router-dom';
import { PAGE_VIEW } from '@bo-constants/analytics/pageViews';
import { useAnalyticsPageViews } from '@bo-hooks/analytics';
import { useMemberFilters } from '@bo-hooks/members';
import { useSentrySetDashBoardTag } from '@bo-hooks/sentry/useSentrySetDashBoardTag';

export const MembersDashboard = () => {
  useSentrySetDashBoardTag({ dashboardName: 'Members' });

  const context: MembersContext = useMemberFilters();

  useAnalyticsPageViews({ pageViewKey: PAGE_VIEW.MEMBERS });

  return <Outlet context={context} />;
};
